// Optional Sentry integration. No-op unless VITE_SENTRY_DSN is set at build
// time. Dynamically imports @sentry/react so the dep can stay optional,
// install with `pnpm add @sentry/react` before setting the DSN.

export async function initSentry(): Promise<boolean> {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return false;
  try {
    // @ts-ignore - optional peer. The /* @vite-ignore */ + variable hop
    // prevents Vite's dep scanner from trying to pre-bundle a package
    // that may not be installed.
    const moduleName = '@sentry/react';
    const mod = await import(/* @vite-ignore */ moduleName);
    mod.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
      tracesSampleRate: 0.1,
      // Don't capture URLs (cases) as user identifiers.
      sendDefaultPii: false,
    });
    return true;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('sentry: VITE_SENTRY_DSN set but @sentry/react not installed', err);
    return false;
  }
}
